/**
 * @flow
 * @author: Manikanta
 */

/* eslint-disable no-confusing-arrow */

import styled from 'react-emotion'
import BaseInput from '../../../commons/BaseInput'
import { customDevice } from '../../../utils/mixins'
import Colors from '../../../themes/Colors'
import {
  Typo12DullRedDR,
  Typo13DarkGreyBlueDR
} from '../../../themes/Fonts/Din2014'

export const MainContainer = styled('div')`
  @media (min-width: 992px) and (max-width: 1352px) {
    width: auto;
  }
  width: ${props => (props.isMobile ? '280px' : '220px')};
  height: 38px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  background-color: ${Colors.iceBlue};
  box-shadow: ${props =>
    props.isFocused ? `0 1px 9px 0 ${Colors.twilightBlue15}` : undefined};
  border: solid 1px
    ${props =>
      props.displayError
        ? Colors.dullRed
        : props.isFocused ? Colors.lightNavyThree : Colors.lightBlueGreyThree};
  box-sizing: border-box;
  flex-direction: row;
  justify-content: center;
  width: ${props =>
    props.isBhowaniporePresentInQueryParams ? 'auto' : '220px'};
  ${customDevice(320, 991)} {
    width: ${props =>
      props.isBhowaniporePresentInQueryParams ? 'auto' : '280px'};
  }
`
export const Icon = styled('img')`
  object-fit: contain;
`

export const IconView = styled('div')`
  padding-left: 14px;
  padding-right: 10px;
  user-select: none;
`
export const CustomInput = styled(BaseInput)`
  background-color: ${Colors.iceBlue};
  border-radius: 2px;
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  font-family: din-2014;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  color: ${props =>
    props.isFocused ? Colors.twilightBlueTwo : Colors.charcoalGrey};
  ':focus': {
    border: none;
    outline: none;
  }
  ::placeholder {
    color: ${Colors.blueyGreyThree};
    line-height: 1.43;
  }

  :-ms-input-placeholder {
    color: ${Colors.blueyGreyThree};
    line-height: 1.43;
  }

  ::-ms-input-placeholder {
    color: ${Colors.blueyGreyThree};
    line-height: 1.43;
  }
  ::-moz-placeholder {
    color: ${Colors.blueyGreyThree};
    line-height: 2.43;
  }
`
export const ErrorText = styled(Typo12DullRedDR)`
  margin-top: 5px;
`

export const LabelText = styled(Typo13DarkGreyBlueDR)`
  display: block;
  margin-bottom: 3px;
  line-height: 1.428;
  color: ${props =>
    props.displayError
      ? Colors.dullRed
      : props.isMobile ? Colors.whiteTwo : undefined};
`

export const IconContainer = styled('div')`
  user-select: none;
  width: 11px;
  height: 100%;
`
export const InputContainer = styled('div')`
  @media (min-width: 992px) and (max-width: 1352px) {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  @media (min-width: 1025px) {
    flex: ${props => (props.isBhowaniporePresentInQueryParams ? 0.8 : 1)};
    min-width: ${props =>
      props.isBhowaniporePresentInQueryParams ? '120px' : 'auto'};
  }
`



// WEBPACK FOOTER //
// ./src/components/FormHomePage/Input/styledComponents.js